import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { isMobile } from 'react-device-detect';
type StreamDuration = {
  streamId: string;
  duration: string;
};
interface EventState {
  autofill: boolean;
  isSidebarOpen: boolean;
  isHeaderOpen: boolean;
  isChatOpen: boolean;
  freeView: boolean;
  holdNames: string;
  holdNamesOnMouse: boolean;
  isShowAd: boolean;
  eventId: string;
  eventOwner: string;
  isChangeStream: string;
  confMode: boolean;
  showEventInfo: boolean;
  isMiami: boolean;
  currentViewer?: number;
  timeCode?: boolean;
  streamDuration?: StreamDuration[];
}

const isMiami =
  typeof window !== 'undefined' && localStorage.getItem('isMiami')
    ? JSON.parse(localStorage.getItem('isMiami') as string)
    : true;
const initialState: EventState = {
  autofill: true,
  isSidebarOpen: true,
  isHeaderOpen: true,
  isChatOpen: isMobile ? false : true,
  isMiami: isMiami,
  freeView: false,
  holdNames: 'hover_only',
  holdNamesOnMouse: false,
  isShowAd: false,
  eventId: '',
  eventOwner: '',
  isChangeStream: '',
  confMode: false,
  showEventInfo: false,
  timeCode: false,
  currentViewer: 0,
  streamDuration: [],
};

const eventSlice = createSlice({
  name: 'event',
  initialState,
  reducers: {
    toggleAutoFill: (state) => {
      state.autofill = !state.autofill;
    },
    setIsSidebarOpen: (state, action: PayloadAction<boolean>) => {
      state.isSidebarOpen = action.payload;
    },
    setIsHeaderOpen: (state, action: PayloadAction<boolean>) => {
      state.isHeaderOpen = action.payload;
    },
    setIsChatOpen: (state, action: PayloadAction<boolean>) => {
      state.isChatOpen = action.payload;
    },
    setFreeView: (state, action: PayloadAction<boolean>) => {
      state.freeView = action.payload;
    },
    setHoldNames: (state, action: PayloadAction<string>) => {
      state.holdNames = action.payload;
    },
    setHoldNamesOnMouse: (state, action: PayloadAction<boolean>) => {
      state.holdNamesOnMouse = action.payload;
    },
    setIsShowAd: (state, action: PayloadAction<boolean>) => {
      state.isShowAd = action.payload;
    },
    setReduxEventId: (state, action: PayloadAction<string>) => {
      state.eventId = action.payload;
    },
    setConfMode: (state, action: PayloadAction<boolean>) => {
      state.confMode = action.payload;
    },
    setIsChangeStream: (state, action: PayloadAction<string>) => {
      state.isChangeStream = action.payload;
    },
    setShowEventInfo: (state, action: PayloadAction<boolean>) => {
      state.showEventInfo = action.payload;
    },
    setControlTheme: (state, action: PayloadAction<boolean>) => {
      state.isMiami = action.payload;
      localStorage.setItem('isMiami', JSON.stringify(state.isMiami));
    },
    setEventOwner: (state, action: PayloadAction<string>) => {
      state.eventOwner = action.payload;
      localStorage.setItem('isMiami', JSON.stringify(state.isMiami));
    },
    setCurrentViewer: (state, action: PayloadAction<number>) => {
      state.currentViewer = action.payload;
    },
    setTimeCode: (state, action: PayloadAction<boolean>) => {
      state.timeCode = action.payload;
    },
    setDurationForStreamer: (state, action: PayloadAction<StreamDuration>) => {
      const index = state.streamDuration.findIndex(
        (stream) => stream.streamId === action.payload.streamId
      );
      if (index !== -1) {
        // Update existing stream duration
        state.streamDuration[index] = action.payload;
      } else {
        // Add new stream duration
        state.streamDuration.push(action.payload);
      }
    },
  },
});

export const {
  toggleAutoFill,
  setIsSidebarOpen,
  setIsHeaderOpen,
  setIsChatOpen,
  setFreeView,
  setHoldNames,
  setHoldNamesOnMouse,
  setIsShowAd,
  setReduxEventId,
  setConfMode,
  setIsChangeStream,
  setShowEventInfo,
  setControlTheme,
  setEventOwner,
  setCurrentViewer,
  setTimeCode,
  setDurationForStreamer,
} = eventSlice.actions;
export default eventSlice.reducer;
